import { businessAreasRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useInvalidateBusinessAreaQueries } from '../hooks/use-invalidate-business-areas-queries';
import { DisassociateBusinessAreaUserModel } from '../types/disassociate-business-area-user-model';

export const useDisassociateBusinessAreaUser = () => {
  const invalidateQueries = useInvalidateBusinessAreaQueries();
  const { t } = useTranslation();
  return useMutation<void, unknown, DisassociateBusinessAreaUserModel>(
    (dissassociateUserBusinessArea) =>
      businessAreasRepo.disassociateUser(dissassociateUserBusinessArea),
    {
      onSuccess: () => invalidateQueries(),
      onError: () => {
        toast.error(t('error.disassociate_user_business_area'));
      },
    },
  );
};
